import React, { useCallback, useEffect, useState } from 'react';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import SecondaryTabbedComponent from '../../shared/components/layout/SecondaryTabbedComponent';
import { useLocation, useParams } from 'react-router-dom';
import { SalesList } from './SalesList';
import CustomerList from './CustomerList';
import ConsolidatedList from './ConsolidatedList';
import UnderConsiderationList from './UnderConsiderationList';
import { useSidebar } from '../../shared/contexts/SidebarContext';
// import Modal from '../../shared/components/ui/Modal';
import Cookies from 'js-cookie';
import Headroom from 'react-headroom';
import mixpanel from 'mixpanel-browser';

const SalesMain = () => {
  const { id: projectId } = useParams();
  const { collapsed } = useSidebar();
  const location = useLocation();
  const status = location.state?.status;
  const userId = Cookies.get('userId');

  // Track component mount

  // Track page view
  useEffect(() => {
    mixpanel.track('Sales Main Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    mixpanel.track('Sales Main Viewed', {
      user_id: userId,
      project_id: projectId,
      initial_status: status,
      timestamp: new Date().toISOString()
    });
  }, []);

  // Helper function to get saved tab from localStorage
  const getSavedPrimaryTab = () => {
    try {
      return localStorage.getItem('salesMainPrimaryTab') || 'Details';
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return 'Details';
    }
  };

  // Helper function to save tab to localStorage
  const savePrimaryTab = (tab) => {
    try {
      localStorage.setItem('salesMainPrimaryTab', tab);
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  };

  // Helper function to get saved secondary tab from localStorage
  const getSavedSecondaryTab = () => {
    try {
      return localStorage.getItem('salesMainSecondaryTab') || 'Leads';
    } catch (error) {
      console.error('Error reading secondary tab from localStorage:', error);
      return 'Leads';
    }
  };

  // Helper function to save secondary tab to localStorage
  const saveSecondaryTab = (tab) => {
    try {
      localStorage.setItem('salesMainSecondaryTab', tab);
    } catch (error) {
      console.error('Error saving secondary tab to localStorage:', error);
    }
  };

  /* 
        Data fetching
      */

  /* 
        Data mutation
      */

  /*
        Hooks 
      */

  /* 
        Local state 
      */
  const [primaryTab, setPrimaryTab] = useState(getSavedPrimaryTab());
  const [secondaryTab, setSecondaryTab] = useState(() => {
    // If status is passed, it's a filter value, not a tab name
    // So we should default to 'Leads' tab
    return status ? 'Leads' : getSavedSecondaryTab();
  });
  const [statusFilter, setStatusFilter] = useState(status || null);
  const [OpenAccommodation, setOpenAccommodation] = useState(false);
  const [isOpenAddDetailsModal, setIsOpenAddDetailsModal] = useState(false);
  const [isOpenBlockDetailingModal, setIsOpenBlockDetailingModal] = useState(false);
  const [isOpenUnitDetailingModal, setIsOpenUnitDetailingModal] = useState(false);
  const [isOpenImportAccommodation, setisOpenImportAccommodation] = useState(false);
  const [isOpenEditAccommodation, setIsOpenEditAccommodation] = useState(false);

  useEffect(() => {
    const statusFromState = location.state?.status;
    if (statusFromState) {
      // Set the tab to 'Leads' and set the status filter
      setSecondaryTab('Leads');
      setStatusFilter(statusFromState);
      saveSecondaryTab('Leads');
    }
  }, [location.state]);

  /* 
        Meta data
      */
  const tabbedComponentMetaData = {
    tabs: ['Details', 'Documents', 'Schedule']
  };

  // const secondaryTabbedComponentMetaData = {
  //   tabs: ['Leads','Under Consideration', 'Closed Customers', 'Invoices', 'Payment', 'Consolidated View of Sales']
  // };

  const [secondaryTabbedComponentMetaData, setTabbedComponentMetaData] = useState({
    tabs: ['Leads', 'Under Consideration', 'Closed Won']
  });

  useEffect(() => {
    const userVertical = Cookies.get('userVertical');
    const vertical = userVertical?.toLowerCase();

    if (vertical === 'management') {
      setTabbedComponentMetaData((prev) => ({
        ...prev,
        tabs: [...prev.tabs, 'Consolidated View of Sales']
      }));
    }
  }, []);

  /* 
        Event handlers
      */
  const handleChangePrimaryTab = useCallback(
    (tabName) => {
      setPrimaryTab(tabName);
      savePrimaryTab(tabName); // Save to localStorage when tab changes

      // Track primary tab change
      mixpanel.track('Sales Main Primary Tab Changed', {
        user_id: userId,
        tab: tabName,
        project_id: projectId,
        timestamp: new Date().toISOString()
      });
    },
    [userId, projectId]
  );

  const handleChangeSecondaryTab = useCallback(
    (tabName) => {
      setSecondaryTab(tabName);
      saveSecondaryTab(tabName); // Save to localStorage when secondary tab changes

      // Track secondary tab change
      mixpanel.track('Sales Main Secondary Tab Changed', {
        user_id: userId,
        tab: tabName,
        project_id: projectId,
        timestamp: new Date().toISOString()
      });
    },
    [userId, projectId]
  );

  /* 
        Effects
      */
  useEffect(() => {
    if (isOpenAddDetailsModal) {
      // console.log('Preventing scroll');
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpenAddDetailsModal]);

  /* 
        JSX
      */
  return (
    <>
      {/* Main content */}
      <Layout>
        {/* Header */}
        <div
          className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
    ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
  `}>
          <Header data={{ name: `Sales` }} />
        </div>

        {/* Primary Tabbed content */}
        {/* <div className="w-full fixed top-[4rem] z-50 bg-orange-600">
                    <PrimaryTabbedComponent
                        width={10}
                        data={tabbedComponentMetaData}
                        activePrimary={primaryTab}
                        onChangePrimaryTab={(tab) => handleChangePrimaryTab(tab)}
                    />
                </div> */}

        {/* Secondary Tabbed content */}
        <div className={`transition-all duration-300 ease-in-out ${collapsed ? 'ml-[1vw]' : ''}`}>
          <Headroom
            upTolerance={0}
            downTolerance={10}
            offset={10}
            style={{
              position: 'fixed',
              top: '4rem',
              left: collapsed ? '76px' : '16.6%',
              right: '0',
              zIndex: 2,
              transition: 'all 0.3s ease-in-out'
            }}>
            <SecondaryTabbedComponent
              data={secondaryTabbedComponentMetaData}
              activePrimary={secondaryTab}
              onChangePrimaryTab={(tab) => handleChangeSecondaryTab(tab)}>
              {/* Buttons section for overview */}

              {/* Buttons section for Accommodation */}
            </SecondaryTabbedComponent>
          </Headroom>

          {/* Overview content */}
          {secondaryTab === 'Leads' && (
            <div className="bg-orange-600 w-full h-full">
              <SalesList statusFilter={statusFilter} />
            </div>
          )}

          {secondaryTab === 'Under Consideration' && (
            <div className="w-full h-full mt-[4.4rem]">
              <UnderConsiderationList />
            </div>
          )}

          {/* PLC content */}
          {primaryTab === 'Details' && secondaryTab === `Closed Won` && (
            <div className=" w-full h-full ">
              <CustomerList />
            </div>
          )}

          {primaryTab === 'Details' && secondaryTab === `Consolidated View of Sales` && (
            <div className=" w-full h-full ">
              <ConsolidatedList />
            </div>
          )}
        </div>
      </Layout>
    </>
  );
};

export default SalesMain;
